const getters = {
  selectedNotesToApuration: (state) => state.notesFromDB,
  getNoteById:
    ({ notesFromDB }) =>
    (idNfe) => {
      if (!idNfe) return;
      return notesFromDB.tBody.filter((item) => item.idNfe === idNfe);
    },
  getItensByIdNfe: (state) => (idNfe) => {
    if (!idNfe) return;
    return state.itensFromXML.filter((item) => item.idNf === idNfe);
  },
  getReferencedItems: (_, getters) => (idNfe) => {
    const [{ cpfCnpj }] = getters.getNoteById(idNfe);
    const [{ itens: { tBody } = {} }] = getters.getItensByIdNfe(idNfe);
    const hasReferenced = tBody
      .filter((item) => item.referenced)
      .map((item) => ({ ...item, cpfCnpj }));
    return hasReferenced;
  },
  getTotalApuredByNote:
    ({ itensFromXML }) =>
    (idNfe) => {
      const [
        {
          itens: { tBody },
        },
      ] = itensFromXML.filter((item) => item.idNf === idNfe);
      if (!tBody) return;
      const itemsCells = tBody
        .filter((item) => item.referenced)
        .flatMap((item) => item.cells);

      return itemsCells.reduce(
        (acc, { name, value }) => {
          if (!["pDifal", "vBcDifal", "vDifal"].includes(name)) return acc;
          if (name === "pDifal") acc.pDifal += value;
          if (name === "vBcDifal") acc.vBcDifal += value;
          if (name === "vDifal") acc.vDifal += value;
          return acc;
        },
        { pDifal: 0, vBcDifal: 0, vDifal: 0 },
      );
    },
  getSelectedNote: (state) => state.selectedNote,
  getKeys: (state) => state.keys,
  getTotalDifalApured: (state) => state.totalDifalApured,
};

export default getters;
